export default {
  // userInfo: state => state.user.userInfo
  menuList: (state) => state.user.menuList,
  userInfo: (state) => state.user.userInfo,
  firstMenu: (state) => {
    let menus = state.user.userInfo.menus;
    let menuList = state.user.menuList;
    if (menus.includes('home')) {
      return 'home';
    } else {
      for (let item of menuList) {
        if (menus.includes(item.key)) {
          if (item.children) {
            for (let child of item.children) {
              if (menus.includes(child.key)) {
                return child.key;
              }
            }
          } else {
            return item.key
          }
        }
      }
    }
  }
}
